// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j9-3";
export var downloadButton = "_j9-4";
export var fileContainer = "_j9-9 _j9-7";
export var fileContainerBase = "_j9-7";
export var fileContainerBaseSm = "_j9-a _j9-7";
export var fileContainerFixedHeight = "_j9-8 _j9-7";
export var fileContainerFixedHeightSm = "_j9-c _j9-a _j9-7";
export var fileContainerSm = "_j9-b _j9-a _j9-7";
export var fileInfo = "_j9-5";
export var fileInfoWidthRestricted = "_j9-6";
export var fileType = "_j9-1";
export var fileTypeName = "_j9-2";
export var fileTypeSm = "_j9-d _j9-1";
export var image = "_j9-0";
export var link = "_j9-f";
export var overflowEllipsis = "_j9-e";